import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoggedUserService } from '@core/service/logged-user.service';

export const FORCE_PASSWORD_CHANGE_PATH = '/cambio-password';

// Keeps the user out of the platform until the password forced by the backoffice is changed
export const forcePasswordChangeGuard: CanActivateFn = () =>
  inject(LoggedUserService).user?.forcePasswordChange
    ? inject(Router).createUrlTree([FORCE_PASSWORD_CHANGE_PATH])
    : true;

// The mandatory change password page is reachable only while the change is due
export const mustChangePasswordGuard: CanActivateFn = () =>
  inject(LoggedUserService).user?.forcePasswordChange ? true : inject(Router).createUrlTree(['/']);
